import ConfigComponent from './ConfigComponent';

export default ConfigComponent;
